// extracted by mini-css-extract-plugin
export default {"gradientBox":"GradientBox_gradientBox__5+uCY","gradientBoxBefore":"GradientBox_gradientBoxBefore__zO7YC"};